module.exports = __webpack_public_path__ + "img/9788925558165.08652217.jpg";